<script setup>
import PwaUpdateBanner from '@/components/PwaUpdateBanner.vue'
</script>

<template>
  <div class="container">
    <RouterView />
    <!-- Banner de actualización PWA: se muestra sólo cuando hay nueva versión -->
    <PwaUpdateBanner />
  </div>
</template>

<style scoped>
</style>
